
import * as React from 'react';
import * as PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import * as api from '../../../store/apiClient';
import * as auth from '../../../utils/auth';
import { ApplicationState } from '../../../store';
import * as CustomerActions from '../../../store/pages/customer/actions';
import { clickHandler } from '../../../utils/util';
import ApiError from '../../global/apiError';

interface LocalProps {
    customerId: string;
    firstname?: string;
    lastname?: string;
    close: (reinstated: boolean) => void;
}

interface MappedState {
    isUpdatingStatus: boolean;
    statusChangeComplete: boolean;
    statusChangeError: api.ApiError | null;
}

interface Actions {
    reinstateCustomer: (customerId: string) => void;
}

type ConfirmReinstateCustomerProps = LocalProps & MappedState & Actions;

class ConfirmReinstateCustomer extends React.Component<ConfirmReinstateCustomerProps, {}> {

    static contextTypes = {
        t: PropTypes.func
    }

    componentDidUpdate(prevProps: ConfirmReinstateCustomerProps) {
        if (this.props.statusChangeComplete && !prevProps.statusChangeComplete) {
            this.props.close(true);
        }
    }

    reinstate = () => this.props.reinstateCustomer(this.props.customerId);

    render() {
        const { firstname, lastname, close, isUpdatingStatus, statusChangeError } = this.props;
        const { t } = this.context;

        return (
            <div>
                <h3>{t('ConfirmReinstateCustomer:heading')}</h3>

                <div className='alert alert-warning'>{t('ConfirmReinstateCustomer:message', { name: `${firstname ?? ''} ${lastname ?? ''}` })}</div>

                {statusChangeError ? <ApiError error={statusChangeError} /> : null}

                <form className='data-form mt-15' onSubmit={e => e.preventDefault()} autoComplete='off'>
                    <div className='row form-group'>
                        <div className='col-md-12 btn-toolbar'>
                            {auth.isSystemAdmin() ? <button className='btn btn-primary' disabled={isUpdatingStatus} onClick={e => clickHandler(e, this.reinstate)}>{t('ConfirmReinstateCustomer:confirmReinstate')}</button> : null}
                            <button className='btn btn-basic' disabled={isUpdatingStatus} onClick={e => clickHandler(e, () => close(false))}>{t('Global:cancel')}</button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    isUpdatingStatus: state.customers.isUpdatingStatus,
    statusChangeComplete: state.customers.statusChangeComplete,
    statusChangeError: state.customers.statusChangeError,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    reinstateCustomer: bindActionCreators(CustomerActions.actionCreators.reinstateCustomer, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmReinstateCustomer);
